// 群聊身份
export const GroupIdentity = {
    BUYER: 1, // 买家
    SELLER: 2, // 卖家
    OWNER: 3 // 群主
}

// 是否全职人员
export const workIdentityEnum = {
    FULL_TIME: 1, // 全职
    PART_TIME: 0, // 兼职
    LABEL: 3, // 低价咨询客服
    OUTSOURCING: 5 // 外包客服
}
export function groupMembership (member, groupList) {
    // 群主
    if (member?.isGroupMgr && member?.identity === GroupIdentity.OWNER) {
        return '<img src="https://oss.pzds.com/pc-ssr-im/groupOwner.png" style="width: 28px;height: 14px;" alt="群主">'
    }
    // 管理员(identity 4（流程客服） 5（审核客服）)
    if (member?.isGroupMgr && member?.identity !== GroupIdentity.OWNER) {
        return '<img src="https://oss.pzds.com/pc-ssr-im/groupAdmin.png" style="width: 38px;height: 14px;" alt="管理员">'
    }
    // 买家
    if (!member?.isGroupMgr && member?.identity === GroupIdentity.BUYER) {
        return '<img src="https://oss.pzds.com/mobileV3/202508061523627.png" style="width: 28px;height: 14px;" alt="买家">'
    }
    // 卖家
    if (!member?.isGroupMgr && member?.identity === GroupIdentity.SELLER) {
        return '<img src="https://oss.pzds.com/mobileV3/202508061523628.png" style="width: 28px;height: 14px;" alt="卖家">'
    }

    const _member_user_id = member?.content?.user?.id
    // 这里单独处理聊天消息
    if (_member_user_id) {
        if (String(_member_user_id)?.length < 9) {
            return '<img src="https://oss.pzds.com/mobileV3/202508051641935.png" style="width: 28px;height: 14px;" alt="官方">'
        }

        // 群聊处理买卖家身份
        if (member?.conversationType == 3 && groupList) {
            const roleObj = groupList?.filter(res => +res?.id === +member?.content?.user?.id)[0] || {}
            if (!roleObj?.isGroupMgr && roleObj?.identity === GroupIdentity.BUYER) {
                return '<img src="https://oss.pzds.com/mobileV3/202508061523627.png" style="width: 28px;height: 14px;" alt="买家">'
            }
            if (!roleObj?.isGroupMgr && roleObj?.identity === GroupIdentity.SELLER) {
                return '<img src="https://oss.pzds.com/mobileV3/202508061523628.png" style="width: 28px;height: 14px;" alt="卖家">'
            }
        }
    }
    return null
}
